import { render, staticRenderFns } from "./RxDetails.vue?vue&type=template&id=2d0630ba&scoped=true"
import script from "./RxDetails.vue?vue&type=script&lang=js"
export * from "./RxDetails.vue?vue&type=script&lang=js"
import style0 from "./RxDetails.vue?vue&type=style&index=0&id=2d0630ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0630ba",
  null
  
)

export default component.exports